(function () {
'use strict';
function initialize(root) {
  if (root.dataset.mfSheetInitialized) return;
  var btn = root.querySelector('#mf-product-info-btn');
  var data = root.querySelector('[data-mf-sheet-data]');
  if (!btn || !data) return;
  var productData;
  try { productData = JSON.parse(data.textContent); } catch (error) { console.error('Product information data could not be read', error); return; }
  root.dataset.mfSheetInitialized = 'true';
  var completeProductSheet = true;
var sheetWindow = null;
var resourceMode = new URLSearchParams(window.location.search).get("mf_sheet") === "1";

var logoUrl =
"https://cdn.shopify.com/s/files/1/0726/1634/5891/files/Modofire-Logo-2025-Black.png?v=1741197819";


/* =========================================================
   HELPERS
========================================================= */

function escapeHtml(value) {
  return String(value == null ? "" : value).replace(
    /[&<>"']/g,
    function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    }
  );
}

function normalizeText(value) {
  return String(value || "")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+/g, " ")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

function cleanLabel(value) {
  return normalizeText(value)
    .replace(/\(\s*[+-]?\s*(?:from\s*)?(?:US\s*)?\$[\d,.]+\s*\)/gi, "")
    .replace(/[:*]+$/g, "")
    .replace(/\b(required|optional)\b/gi, "")
    .replace(/\+\s*\$[\d,.]+/g, "")
    .trim();
}

function isPlaceholder(value) {
  return /^(choose|select|pick|please select|none|--|—)$/i.test(
    normalizeText(value)
  );
}

function fixUrl(url) {
  if (!url) return "";

  if (url.indexOf("//") === 0) {
    return "https:" + url;
  }

  return url;
}

function formatMoneyFromCents(cents) {
  var amount =
    Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat(
      "en-US",
      {
        style: "currency",
        currency:
          productData.currency || "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    ).format(amount);

  } catch (error) {
    return "$" +
      Math.round(amount).toLocaleString();
  }
}

function getProductScope() {
  return btn.closest('[id^="shopify-section-"]') || btn.closest('main') || document.body;
}

function getDateData() {
  var date =
    new Date();

  return {
    display:
      date.toLocaleDateString(
        "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      ),

    file:
      date.getFullYear() +
      "-" +
      String(
        date.getMonth() + 1
      ).padStart(2, "0") +
      "-" +
      String(
        date.getDate()
      ).padStart(2, "0")
  };
}


/* =========================================================
   EASIFY OPTIONS
========================================================= */

function collectEasifyGroups(scope) {
  var groups = [];
  var byLabel = {};

  function addGroup(label, values, order, conditionText) {
    label = cleanLabel(label);

    if (!label || label.length > 180) return;

    var key = label.toLowerCase();

    if (!byLabel[key]) {
      byLabel[key] = {
        label: label,
        values: [],
        relations: [],
        order:
          typeof order === "number"
            ? order
            : groups.length + 1000
      };

      groups.push(byLabel[key]);
    }

    var cleanedChoices = [];

    (values || []).forEach(function (value) {
      value = cleanLabel(value);

      if (
        value &&
        value.length < 300 &&
        !isPlaceholder(value) &&
        !/^option[_\s-]*\d+$/i.test(value)
      ) {
        cleanedChoices.push(value);

        if (byLabel[key].values.indexOf(value) === -1) {
          byLabel[key].values.push(value);
        }
      }
    });

    if (conditionText && cleanedChoices.length) {
      try {
        var condition = JSON.parse(conditionText);

        var variantConditions =
          (condition.conditionOptions || []).filter(function (item) {
            return String(item.id || "").toLowerCase() === "variant";
          });

        if (
          condition.action === "SHOW" &&
          variantConditions.length
        ) {
          var relationKey =
            JSON.stringify(variantConditions) +
            "|" +
            cleanedChoices.join("|");

          var relationExists =
            byLabel[key].relations.some(function (relation) {
              return relation.key === relationKey;
            });

          if (!relationExists) {
            byLabel[key].relations.push({
              key: relationKey,
              match: condition.match || "ANY",
              conditions: variantConditions,
              values: cleanedChoices
            });
          }
        }
      } catch (error) {
      }
    }
  }

  function isEnabled(value) {
    var metadata = {};
    try { metadata = typeof value.metadata === 'string' ? JSON.parse(value.metadata) : value.metadata || {}; } catch (error) {}
    return ![true, 1, '1', 'true'].includes(value.disabled) && ![true, 1, '1', 'true'].includes(metadata.disabled);
  }

  function variantApplies(field, variant) {
    var rules;
    try { rules = JSON.parse(field.conditions_serialized || '{}'); } catch (error) { return false; }
    if (rules.conditionalField === false || !rules.conditionOptions || !rules.conditionOptions.length) return true;
    var variantRules = rules.conditionOptions.filter(function (rule) { return String(rule.id).toLowerCase() === 'variant'; });
    if (!variantRules.length) return true;
    var matches = variantRules.map(function (rule) { return conditionMatchesVariant(rule, variant); });
    var matched = String(rules.match).toUpperCase() === 'ALL' ? matches.every(Boolean) : matches.some(Boolean);
    return String(rules.action).toUpperCase() === 'HIDE' ? !matched : matched;
  }

  function readChoices(field) {
    var values = [];
    field.querySelectorAll("option,[role='option'],.po-optionSwatch-labelText,.po-optionItemLabel-label,.po-switch-label,[data-option-value],.po-imageOption-swatchWrapperItem img[alt]").forEach(function (choice) {
      if (choice.disabled || choice.closest('[aria-disabled="true"],[hidden],[aria-hidden="true"]')) return;
      values.push(choice.getAttribute('data-option-value') || choice.getAttribute('alt') || choice.innerText || choice.textContent || '');
    });
    return values;
  }

  var pageLabels = {};
  var pageMarkup = {};
  var pageOrder = [];
  var currentId = scope.querySelector('form[action*="/cart/add"] [name="id"]');
  var selectedId = currentId && currentId.value || new URLSearchParams(window.location.search).get('variant');
  var currentVariant = productData.variants.find(function (variant) { return String(variant.id) === String(selectedId); }) || productData.variants.find(function (variant) { return variant.available; }) || productData.variants[0];

  scope.querySelectorAll('.po-field-root').forEach(function (field) {
    var style = window.getComputedStyle(field);
    if (field.hidden || field.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden' || field.getClientRects().length === 0) return;
    var labelElement = field.querySelector('.po-label-labelContent,.po-label-label,legend,[data-option-title]');
    var label = cleanLabel(labelElement ? labelElement.textContent : '');
    if (!label) return;
    var key = label.toLowerCase();
    pageLabels[key] = true;
    pageMarkup[key] = (pageMarkup[key] || '') + field.outerHTML;
    if (!pageOrder.includes(key)) pageOrder.push(key);
    addGroup(label, readChoices(field), pageOrder.indexOf(key) + 1, null);
    if (byLabel[key]) byLabel[key].liveValues = byLabel[key].values.slice();
  });

  function extractBalancedObject(text, fromIndex) {
    var start = text.indexOf("{", fromIndex);
    var depth = 0;
    var quote = "";
    var escaped = false;

    if (start < 0) return "";

    for (
      var index = start;
      index < text.length;
      index += 1
    ) {
      var character = text.charAt(index);

      if (quote) {
        if (escaped) {
          escaped = false;
        } else if (character.charCodeAt(0) === 92) {
          escaped = true;
        } else if (character === quote) {
          quote = "";
        }

        continue;
      }

      if (
        character === "\"" ||
        character === "'"
      ) {
        quote = character;
      } else if (character === "{") {
        depth += 1;
      } else if (character === "}") {
        depth -= 1;

        if (depth === 0) {
          return text.slice(
            start,
            index + 1
          );
        }
      }
    }

    return "";
  }

  function collectConfiguredFields(value, output) {
    if (
      !value ||
      typeof value !== "object"
    ) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        collectConfiguredFields(
          item,
          output
        );
      });

      return;
    }

    if (
      value.title &&
      Array.isArray(value.option_types)
    ) {
      output.push(value);
    }

    Object.keys(value).forEach(function (key) {
      collectConfiguredFields(
        value[key],
        output
      );
    });
  }

  Array.prototype.slice.call(
    document.scripts
  ).forEach(function (script) {
    var text =
      script.textContent || "";

    var marker =
      text.indexOf(
        "option_sets_searchable"
      );

    if (
      marker < 0 ||
      text.indexOf(
        "option_types",
        marker
      ) < 0
    ) {
      return;
    }

    var dataIndex =
      text.indexOf(
        "data:",
        marker
      );

    while (dataIndex >= 0) {
      var raw =
        extractBalancedObject(
          text,
          dataIndex + 5
        );

      if (!raw) break;

      try {
        var optionSet =
          JSON.parse(raw);

        var configuredFields =
          [];

        collectConfiguredFields(
          optionSet.options ||
          optionSet,
          configuredFields
        );

        if (Number(optionSet.status) !== 1) throw new Error('Inactive option set');
        var activeMarkup = Object.values(pageMarkup).join('');
        if (!configuredFields.some(function (field) { return field.id && activeMarkup.includes(String(field.id)); })) throw new Error('Option set is not rendered on this product');

        var fieldsById = {};
        configuredFields.forEach(function (field) { fieldsById[field.id] = field; });
        function reachable(field, variant, visiting) {
          if (!field || !isEnabled(field)) return false;
          visiting = visiting || [];
          if (visiting.includes(field.id)) return false;
          var path = visiting.concat(field.id);
          var rules;
          try { rules = JSON.parse(field.conditions_serialized || '{}'); } catch (error) { return false; }
          if (rules.conditionalField === false || !rules.conditionOptions || !rules.conditionOptions.length) return true;
          var matches = rules.conditionOptions.map(function (rule) {
            if (String(rule.id).toLowerCase() === 'variant') return conditionMatchesVariant(rule, variant);
            var parent = fieldsById[String(rule.id).split(',')[0]];
            if (!reachable(parent, variant, path)) return false;
            var wanted = String(rule.value || '').toLowerCase();
            var choices = parent.option_types.filter(isEnabled);
            var op = String(rule.relative || '').toUpperCase();
            return choices.some(function (choice) {
              var id = String(choice.id || '').toLowerCase();
              var label = String(choice.label || '').toLowerCase();
              if (op === 'EQUAL' || op === 'EQUALS') return id === wanted || label === wanted;
              if (op === 'CONTAIN') return id.includes(wanted) || label.includes(wanted);
              if (op === 'NOT_CONTAIN') return !id.includes(wanted) && !label.includes(wanted);
              return false;
            });
          });
          var result = String(rules.match).toUpperCase() === 'ALL' ? matches.every(Boolean) : matches.some(Boolean);
          return String(rules.action).toUpperCase() === 'HIDE' ? !result : result;
        }

        configuredFields = configuredFields.filter(function (field) {
          var key = cleanLabel(field.title).toLowerCase();
          return isEnabled(field) && !/^(html|text|text-box|textarea|file-upload|heading|paragraph)$/i.test(field.type) && productData.variants.some(function (variant) { return reachable(field, variant); });
        });

        configuredFields
          .sort(function (left, right) {
            return (
              Number(left.sort_order || 0) -
              Number(right.sort_order || 0)
            );
          })
          .forEach(function (field) {
            var fieldKey =
              cleanLabel(
                field.title
              ).toLowerCase();

            if (!fieldKey || /acknowledg|personaliz|upload|additional direction|notes?/i.test(fieldKey)) return;
            pageLabels[fieldKey] = true;
            pageMarkup[fieldKey] = pageMarkup[fieldKey] || '';
            if (!pageOrder.includes(fieldKey)) pageOrder.push(fieldKey);

            var choices =
              field.option_types
                .filter(isEnabled)
                .sort(function (left, right) {
                  return (
                    Number(left.sort_order || 0) -
                    Number(right.sort_order || 0)
                  );
                })
                .map(function (choice) {
                  return choice.label || "";
                });

            addGroup(
              field.title,
              choices,
              pageOrder.indexOf(fieldKey) + 1,
              field.conditions_serialized
            );

            if (completeProductSheet) {
              var completeGroup = byLabel[fieldKey];
              completeGroup.applicability = completeGroup.applicability || {};
              choices.forEach(function (choice) {
                choice = cleanLabel(choice);
                if (!choice || isPlaceholder(choice)) return;
                var ids = completeGroup.applicability[choice] || [];
                productData.variants.forEach(function (variant) {
                  if (reachable(field, variant) && !ids.includes(String(variant.id))) ids.push(String(variant.id));
                });
                if (ids.length) completeGroup.applicability[choice] = ids;
              });
            }

            var exactRenderedField = configuredFields.some(function (candidate) {
              return cleanLabel(candidate.title).toLowerCase() === fieldKey && candidate.id && pageMarkup[fieldKey].includes(String(candidate.id));
            });
            if (variantApplies(field, currentVariant) && (!exactRenderedField || field.id && pageMarkup[fieldKey].includes(String(field.id)))) {
              var group = byLabel[fieldKey];
              if (group && !group.configuredLive) { group.liveValues = []; group.configuredLive = true; }
              choices.forEach(function (choice) {
                choice = cleanLabel(choice);
                if (group && choice && !isPlaceholder(choice) && !group.liveValues.includes(choice)) group.liveValues.push(choice);
              });
            }
          });

      } catch (error) {
      }

      dataIndex =
        text.indexOf(
          "data:",
          dataIndex +
          raw.length +
          5
        );
    }
  });

  groups =
    groups.filter(function (group) {
      return group.values.length > 0;
    });

  groups.sort(function (left, right) {
    return left.order - right.order;
  });

  return groups;
}


/* =========================================================
   VISIBLE OPTION LABELS
========================================================= */

function collectVisibleOptionLabels(scope) {
  var visible = {};

  scope.querySelectorAll(
    ".po-field-root"
  ).forEach(function (field) {
    var style =
      window.getComputedStyle(field);

    if (
      field.hidden ||
      field.getAttribute("aria-hidden") === "true" ||
      style.display === "none" ||
      style.visibility === "hidden" ||
      field.getClientRects().length === 0
    ) {
      return;
    }

    var labelElement =
      field.querySelector(
        ".po-label-label, legend, [data-option-title]"
      );

    var label =
      cleanLabel(
        labelElement
          ? labelElement.innerText ||
            labelElement.textContent
          : ""
      );

    if (label) {
      visible[
        label.toLowerCase()
      ] = true;
    }
  });

  return visible;
}


/* =========================================================
   PRICE TABLE
========================================================= */

function removeChoicePrice(value) {
  return normalizeText(value)
    .replace(
      /\(\s*(?:\+|-)?\s*(?:US\s*)?\$\s*[\d,]+(?:\.\d{2})?\s*\)/gi,
      ""
    )
    .replace(
      /(?:\+|-)?\s*(?:US\s*)?\$\s*[\d,]+(?:\.\d{2})?/gi,
      ""
    )
    .replace(/\(\s*\)/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

function optionType(label) {
  var text =
    cleanLabel(label)
      .toLowerCase();

  if (
    /fire\s*glass.*color|glass.*color|color.*glass/.test(text)
  ) {
    return "hidden";
  }

  if (/burner/.test(text)) {
    return "burner";
  }

  if (
    /ignition|control system|flame sensing/.test(text)
  ) {
    return "ignition";
  }

  if (
    /fire\s*media|media|lava\s*rock|rock/.test(text)
  ) {
    return "media";
  }

  return "";
}

function conditionMatchesVariant(
  condition,
  variant
) {
  if (
    !condition ||
    !variant
  ) {
    return false;
  }

  var expected =
    normalizeText(
      condition.value || ""
    ).toLowerCase();

  if (!expected) return false;

  var variantText =
    (
      variant.options || []
    )
      .join(" ")
      .toLowerCase();

  var relative =
    String(
      condition.relative ||
      "CONTAIN"
    ).toUpperCase();

  if (
    relative === "EQUAL" ||
    relative === "EQUALS"
  ) {
    return (
      variant.options || []
    ).some(function (value) {
      return (
        String(
          value || ""
        ).toLowerCase() ===
        expected
      );
    });
  }

  if (
    relative === "NOT_CONTAIN" ||
    relative === "NOT CONTAIN"
  ) {
    return (
      variantText.indexOf(
        expected
      ) === -1
    );
  }

  return (
    variantText.indexOf(
      expected
    ) !== -1
  );
}

function relationMatchesVariant(
  relation,
  variant
) {
  if (
    !relation ||
    !relation.conditions ||
    !relation.conditions.length
  ) {
    return true;
  }

  var matches =
    relation.conditions.map(
      function (condition) {
        return conditionMatchesVariant(
          condition,
          variant
        );
      }
    );

  if (
    String(
      relation.match || ""
    ).toUpperCase() === "ALL"
  ) {
    return matches.every(Boolean);
  }

  return matches.some(Boolean);
}

function getVariantOptionData(
  variant,
  groups
) {
  var result = {
    burner: [],
    ignition: [],
    media: []
  };

  function addValue(
    type,
    value
  ) {
    if (
      !type ||
      type === "hidden"
    ) {
      return;
    }

    value =
      normalizeText(value);

    if (
      !value ||
      isPlaceholder(value)
    ) {
      return;
    }

    var cleaned =
      removeChoicePrice(value);

    if (
      /^no thanks?$/i.test(cleaned) ||
      /^none$/i.test(cleaned) ||
      /^without/i.test(cleaned)
    ) {
      return;
    }

    if (
      result[type].indexOf(
        value
      ) === -1
    ) {
      result[type].push(
        value
      );
    }
  }

  groups.forEach(function (group) {
    var type =
      optionType(
        group.label
      );

    if (
      !type ||
      type === "hidden"
    ) {
      return;
    }

    if (completeProductSheet && group.applicability) {
      Object.keys(group.applicability).forEach(function (value) {
        if (group.applicability[value].includes(String(variant.id))) addValue(type, value);
      });
      return;
    }

    if (
      group.relations &&
      group.relations.length
    ) {
      group.relations.forEach(
        function (relation) {
          if (
            !relationMatchesVariant(
              relation,
              variant
            )
          ) {
            return;
          }

          (
            relation.values || []
          ).forEach(function (value) {
            addValue(
              type,
              value
            );
          });
        }
      );

      return;
    }

    (
      group.values || []
    ).forEach(function (value) {
      addValue(
        type,
        value
      );
    });
  });

  return result;
}

function getVariantDisplay(variant) {
  var parts = [];

  productData.optionNames.forEach(
    function (
      name,
      index
    ) {
      var value =
        variant.options &&
        variant.options[index]
          ? variant.options[index]
          : "";

      if (
        value &&
        value !== "Default Title"
      ) {
        parts.push(value);
      }
    }
  );

  return parts.length
    ? parts.join(" / ")
    : productData.title;
}

function includedText(
  values,
  fallback
) {
  if (
    !values ||
    !values.length
  ) {
    return escapeHtml(
      fallback || "Included"
    );
  }

  var cleaned = [];

  values.forEach(function (value) {
    var text =
      removeChoicePrice(value);

    if (
      text &&
      cleaned.indexOf(text) === -1
    ) {
      cleaned.push(text);
    }
  });

  if (!cleaned.length) {
    return escapeHtml(
      fallback || "Included"
    );
  }

  return cleaned
    .map(escapeHtml)
    .join("<br>");
}

function defaultIgnitionText(values) {
  if (
    !values ||
    !values.length
  ) {
    return "Included";
  }

  var first =
    removeChoicePrice(
      values[0]
    );

  return first
    ? escapeHtml(first)
    : "Included";
}

function renderMasterPriceTable(groups) {
  var hasBurner = groups.some(function (g) { return optionType(g.label) === 'burner'; });
  var hasIgnition = !completeProductSheet && groups.some(function (g) { return optionType(g.label) === 'ignition'; });
  var hasMedia = groups.some(function (g) { return optionType(g.label) === 'media'; });
  var hasWeight = productData.variants.some(function (v) { return Number(v.grams) > 0; });
  var html = "<table class='master-price-table'><thead><tr><th>Size / Material / SKU</th>";
  if (hasBurner) html += '<th>Burner options</th>';
  if (hasIgnition) html += '<th>Standard ignition</th>';
  if (hasMedia) html += '<th>Fire media</th>';
  if (hasWeight) html += '<th>Approx. weight</th>';
  html += '</tr></thead><tbody>';
  productData.variants.forEach(function (variant) {
    var options = getVariantOptionData(variant, groups);
    html += '<tr><td><strong>' + escapeHtml(getVariantDisplay(variant)) + '</strong>';
    if (variant.sku) html += "<div class='variant-sku'>" + escapeHtml(variant.sku) + '</div>';
    html += '</td>';
    if (hasBurner) html += '<td>' + includedText(options.burner, 'See product options') + '</td>';
    if (hasIgnition) html += '<td>' + (options.ignition.length ? defaultIgnitionText(options.ignition) : 'See product options') + '</td>';
    if (hasMedia) html += '<td>' + includedText(options.media, 'See product options') + '</td>';
    if (hasWeight) html += '<td>' + (Number(variant.grams) > 0 ? Math.round(Number(variant.grams) / 453.59237).toLocaleString() + ' lb' : 'Not listed') + '</td>';
    html += '</tr>';
  });
  html += '</tbody></table>';
  if (completeProductSheet) {
    var standards = productData.variants.map(function (variant) { return getVariantOptionData(variant, groups).ignition[0] || ''; });
    if (standards[0] && standards.every(function (value) { return value === standards[0]; })) html += "<p class='shared-standard'><strong>Standard ignition:</strong> " + escapeHtml(removeChoicePrice(standards[0])) + '. Available upgrades are listed below.</p>';
  }
  return html;
}


/* =========================================================
   AVAILABLE OPTIONS
========================================================= */

function isCoreOptionValueLabel(label) {
  var target =
    cleanLabel(label)
      .toLowerCase();

  var found = false;

  productData.optionGroups.forEach(
    function (group) {
      (group.values || []).forEach(
        function (value) {
          if (
            cleanLabel(value)
              .toLowerCase() ===
            target
          ) {
            found = true;
          }
        }
      );
    }
  );

  return found;
}

function hideAvailableOption(label) {
  var text =
    cleanLabel(label)
      .toLowerCase();

  return (
    /acknowledg/.test(text) ||

    /quantity|add to cart|buy now|payment|shipping|warranty|return|cancel|review|description|product information/.test(text) ||
    isCoreOptionValueLabel(label)
  );
}

function renderAllOptions(
  groups,
  visibleLabels
) {
  var rows = [];
  var seen = {};

  function addRow(
    label,
    values,
    requireVisible
  ) {
    label =
      cleanLabel(label);

    if (
      !label ||
      hideAvailableOption(label)
    ) {
      return;
    }

    if (
      requireVisible &&
      !visibleLabels[
        label.toLowerCase()
      ]
    ) {
      return;
    }

    var cleanedValues =
      (values || [])
        .map(cleanLabel)
        .filter(function (value) {
          return (
            value &&
            value !== "Default Title" &&
            !/^no thanks?$/i.test(value) &&
            !isPlaceholder(value)
          );
        })
        .filter(function (
          value,
          index,
          array
        ) {
          return (
            array.indexOf(value) ===
            index
          );
        });

    var key =
      label
        .toLowerCase()
        .replace(
          /[^a-z0-9]/g,
          ""
        );

    if (
      !key ||
      seen[key] ||
      !cleanedValues.length
    ) {
      return;
    }

    seen[key] = true;

    rows.push({
      label:
        label,
      values:
        cleanedValues
    });
  }

  productData.optionGroups.forEach(
    function (group) {
      if (/^(size|material|dimensions?)$/i.test(group.name)) return;
      addRow(
        group.name,
        group.values,
        false
      );
    }
  );

  var applicableChoices = {};
  groups.forEach(function (group) {
    if (completeProductSheet && ['burner','media'].includes(optionType(group.label))) return;
    var values = completeProductSheet && group.applicability ? Object.keys(group.applicability) : group.liveValues || [];
    applicableChoices[cleanLabel(group.label).toLowerCase()] = group.applicability || {};
    addRow(group.label, values, false);
  });

  if (!rows.length) {
    return (
      "<p class='empty'>" +
        "No additional product options were detected." +
      "<\/p>"
    );
  }

  var html =
    "<table class='all-options-table'>" +
      "<thead>" +
        "<tr>" +
          "<th>Option<\/th>" +
          "<th>Available Choices<\/th>" +
        "<\/tr>" +
      "<\/thead>" +
      "<tbody>";

  rows.forEach(function (row) {
    html +=
      "<tr>" +
        "<td class='option-name'>" +
          escapeHtml(
            row.label
          ) +
        "<\/td>" +
        "<td><ul class='vertical-options'>";

    row.values.forEach(function (value) {
      var note = '';
      var ids = (applicableChoices[row.label.toLowerCase()] || {})[value];
      if (completeProductSheet && ids && ids.length < productData.variants.length) {
        var sizeNames = productData.variants.filter(function (variant) { return ids.includes(String(variant.id)); }).map(function (variant) {
          var sizeIndex = productData.optionNames.findIndex(function (name) { return /size|dimensions?/i.test(name); });
          var size = variant.options[Math.max(0, sizeIndex)] || variant.title;
          var dimensions = String(size).split('•')[0].trim();
          var materialIndex = productData.optionNames.findIndex(function (name) { return /material/i.test(name); });
          var materials = new Set(productData.variants.map(function (item) { return item.options[materialIndex]; }));
          var material = materialIndex >= 0 && materials.size > 1 ? ' / ' + variant.options[materialIndex] : '';
          return dimensions + material;
        }).filter(function (value, index, array) { return array.indexOf(value) === index; });
        note = "<span class='option-applicability'>Sizes: " + escapeHtml(sizeNames.join(', ')) + '</span>';
      }
      html += '<li>' + escapeHtml(removeChoicePrice(value)) + note + '</li>';
    });

    html +=
        "<\/ul><\/td>" +
      "<\/tr>";
  });

  html +=
      "<\/tbody>" +
    "<\/table>";

  return html;
}


/* =========================================================
   ADDITIONAL PRODUCT INFORMATION
========================================================= */

function stripPrintedPrices(value) {
  return String(value || '').replace(/(?:[+-]\s*)?(?:(?:US|CA|AU)\s*)?[$€£]\s*\d[\d,]*(?:\.\d{1,2})?/gi, '').replace(/\b(?:USD|CAD|AUD|EUR|GBP)\s*\d[\d,]*(?:\.\d{1,2})?/gi, '').replace(/\(\s*\)/g, '').replace(/\s{2,}/g, ' ');
}

function panelHtml(title, panel) {
  var clone = panel.cloneNode(true);
  clone.querySelectorAll('script,style,noscript,template,svg,img,video,iframe,form,input,select,textarea,button,summary,meta,.mf-option-tip,.mf-option-guide,[data-ai-field],[data-ai-panel],modofire-ai-studio-v12').forEach(function (node) { node.remove(); });
  clone.querySelectorAll('*').forEach(function (node) {
    Array.from(node.attributes).forEach(function (attribute) {
      if (!['href','colspan','rowspan'].includes(attribute.name)) node.removeAttribute(attribute.name);
    });
    if (node.tagName === 'A') {
      var href = node.getAttribute('href') || '';
      if (!/^(https?:|mailto:|\/|#)/i.test(href)) node.removeAttribute('href');
      else { node.setAttribute('target', '_blank'); node.setAttribute('rel', 'noopener noreferrer'); }
    }
  });
  var textWalker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
  var textNode;
  while ((textNode = textWalker.nextNode())) textNode.textContent = stripPrintedPrices(textNode.textContent);
  var first = clone.firstElementChild;
  if (first && normalizeText(first.textContent).toLowerCase() === title.toLowerCase()) first.remove();
  clone.querySelectorAll('p,div,span').forEach(function (node) { if (!normalizeText(node.textContent) && !node.querySelector('table,ul,ol')) node.remove(); });
  return {html: clone.innerHTML.trim(), text: normalizeText(clone.textContent)};
}

function collectProductSections(scope) {
  var sections = [];
  var seen = new Set();
  var description = normalizeText(productData.description).toLowerCase();
  scope.querySelectorAll('.product-accordion-group .accordion__inner').forEach(function (accordion) {
    if (accordion.closest('.mf-option-guide,.mf-option-tip,[data-mf-sheet],modofire-ai-studio-v12')) return;
    var trigger = accordion.querySelector(':scope > .accordion__label');
    var panel = accordion.querySelector(':scope > .accordion__content');
    if (!trigger || !panel) return;
    var title = cleanLabel(trigger.textContent);
    if (!title || !/[a-z0-9]/i.test(title) || /^(description(?: & details)?|ai design studio|3d.*|lava rock calculator|collapsible row|reviews?)$/i.test(title)) return;
    var content = panelHtml(title, panel);
    var key = content.text.toLowerCase();
    if (key.length < 8 || seen.has(key) || key === description || /add your collapsible row content|build a prompt to review|choose your product options above/i.test(key)) return;
    seen.add(key);
    sections.push({title:title, html:content.html});
  });
  return sections;
}

function renderProductSections(
  sections
) {
  if (!sections.length) {
    return (
      "<p class='empty'>" +
        "No additional product information was detected." +
      "<\/p>"
    );
  }

  var html =
    "<div class='product-detail-list'>";

  sections.forEach(function (section) {
    html +=
      "<section class='detail-card'>" +
        "<h3>" +
          escapeHtml(
            section.title
          ) +
        "<\/h3>" +
        "<div class='detail-body'>" +
          section.html +
        "<\/div>" +
      "<\/section>";
  });

  html +=
    "<\/div>";

  return html;
}


/* =========================================================
   PRODUCT INFORMATION
========================================================= */

function renderProductInformation() {
  var html =
    "<table class='product-info-table'>" +
      "<tbody>" +

        "<tr>" +
          "<td>Product Name<\/td>" +
          "<td>" +
            escapeHtml(
              productData.title
            ) +
          "<\/td>" +
        "<\/tr>" +

        "<tr>" +
          "<td>Availability<\/td>" +
          "<td>" +
            (
              productData.available
                ? "Available"
                : "Check Availability"
            ) +
          "<\/td>" +
        "<\/tr>";

  if (productData.vendor) {
    html +=
      "<tr>" +
        "<td>Brand<\/td>" +
        "<td>" +
          escapeHtml(
            productData.vendor
          ) +
        "<\/td>" +
      "<\/tr>";
  }

  if (productData.productType) {
    html +=
      "<tr>" +
        "<td>Product Type<\/td>" +
        "<td>" +
          escapeHtml(
            productData.productType
          ) +
        "<\/td>" +
      "<\/tr>";
  }

  html +=
        "<tr>" +
          "<td>Product Page<\/td>" +
          "<td>" +
            "<a href='" +
              escapeHtml(
                productData.productUrl
              ) +
            "' target='_blank'>" +
              "View Product Online" +
            "<\/a>" +
          "<\/td>" +
        "<\/tr>" +

        "<tr>" +
          "<td>Contact<\/td>" +
          "<td>" +
            "<a href='mailto:info@modofire.com'>" +
              "info@modofire.com" +
            "<\/a>" +
          "<\/td>" +
        "<\/tr>" +

      "<\/tbody>" +
    "<\/table>";



  return html;
}


/* =========================================================
   IMAGES
========================================================= */

function fetchBase64(url) {
  return fetch(url, { signal: AbortSignal.timeout(6000) })
    .then(function (response) {
      return response.blob();
    })
    .then(function (blob) {
      return new Promise(
        function (resolve) {
          var reader =
            new FileReader();

          reader.onload =
            function () {
              resolve(
                reader.result
              );
            };

          reader.onerror =
            function () {
              resolve(
                null
              );
            };

          reader.readAsDataURL(
            blob
          );
        }
      );
    })
    .catch(function () {
      return null;
    });
}


/* =========================================================
   BUILD DOCUMENT
========================================================= */

function buildDocument(
  imageMap,
  easifyGroups,
  visibleLabels,
  productSections
) {
  var dateData =
    getDateData();

  var logoFixed =
    fixUrl(
      logoUrl
    );

  var logoSource =
    imageMap[
      logoFixed
    ] ||
    logoFixed;

  var logoHtml =
    logoSource
      ? (
        "<img class='logo' src='" +
          logoSource +
          "' alt='Modofire'>"
      )
      : "";

  var imagesHtml =
    "<div class='image-grid'>";

  productData.images
    .slice(
      0,
      3
    )
    .forEach(function (imageUrl) {
      var fixedUrl =
        fixUrl(
          imageUrl
        );

      var source =
        imageMap[
          fixedUrl
        ] ||
        fixedUrl;

      imagesHtml +=
        "<div class='image-cell'>" +
          "<img src='" +
            source +
            "' alt=''>" +
        "<\/div>";
    });

  imagesHtml +=
    "<\/div>";


  var documentHtml =
    "<!DOCTYPE html>" +
    "<html>" +
    "<head>" +
    "<meta charset='utf-8'>" +
    "<meta name='viewport' content='width=device-width,initial-scale=1'>" +

    "<title>" +
      escapeHtml(
        productData.title
      ) +
      " Product Information Sheet" +
    "<\/title>" +

    "<scr" +
    "ipt defer src='https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js'>" +
    "<\/scr" +
    "ipt>" +

    "<style>" +

    "@page{" +
      "size:letter;" +
      "margin:.30in;" +
    "}" +

    "*{" +
      "box-sizing:border-box;" +
    "}" +

    "html,body{" +
      "height:auto!important;" +
      "min-height:0!important;" +
      "max-height:none!important;" +
      "overflow:visible!important;" +
    "}" +

    "body{" +
      "margin:14px;" +
      "background:#e9e9e9;" +
      "color:#111;" +
      "font-family:Arial,Helvetica,sans-serif;" +
      "font-size:10px;" +
      "line-height:1.35;" +
    "}" +

    ".sheet{" +
      "max-width:960px;" +
      "margin:0 auto;" +
      "padding:20px;" +
      "background:#f8f8f8;" +
    "}" +

    ".toolbar{" +
      "display:flex;" +
      "justify-content:flex-end;" +
      "gap:8px;" +
      "margin-bottom:14px;" +
    "}" +

    ".toolbar button{" +
      "padding:10px 15px;" +
      "border:0;" +
      "border-radius:3px;" +
      "background:#111;" +
      "color:#fff;" +
      "font-size:12px;" +
      "font-weight:700;" +
      "cursor:pointer;" +
    "}" +

    ".toolbar .download{" +
      "background:#f49600;" +
    "}" +

    ".header{" +
      "display:flex;" +
      "align-items:flex-start;" +
      "justify-content:space-between;" +
      "gap:20px;" +
      "padding-bottom:12px;" +
      "border-bottom:2px solid #f49600;" +
    "}" +

    ".logo{" +
      "display:block;" +
      "max-width:220px;" +
      "height:45px;" +
      "object-fit:contain;" +
      "object-position:left center;" +
    "}" +

    ".header-text{" +
      "text-align:right;" +
    "}" +

    ".header h1{" +
      "margin:0;" +
      "font-size:24px;" +
      "line-height:1.15;" +
    "}" +

    ".document-name{" +
      "margin:5px 0 0;" +
      "font-size:12px;" +
      "font-weight:700;" +
    "}" +

    ".effective-date{" +
      "margin:3px 0 0;" +
      "color:#666;" +
      "font-size:9px;" +
    "}" +

    ".section-title{" +
      "margin:16px 0 9px;" +
      "padding:8px 10px;" +
      "border-radius:3px;" +
      "background:#f49600;" +
      "color:#fff;" +
      "font-size:11px;" +
      "font-weight:700;" +
      "letter-spacing:.04em;" +
      "text-transform:uppercase;" +
    "}" +

    ".top-grid{" +
      "display:grid;" +
      "grid-template-columns:1.25fr .75fr;" +
      "align-items:start;" +
      "gap:14px;" +
    "}" +

    ".image-grid{" +
      "display:grid;" +
      "grid-template-columns:repeat(3,minmax(0,1fr));" +
      "gap:8px;" +
    "}" +

    ".image-cell{" +
      "aspect-ratio:1/1;" +
      "overflow:hidden;" +
      "border-radius:3px;" +
      "background:#e5e5e5;" +
    "}" +

    ".image-cell img{" +
      "display:block;" +
      "width:100%;" +
      "height:100%;" +
      "object-fit:cover;" +
    "}" +

    ".product-info-table{" +
      "width:100%;" +
      "border-collapse:collapse;" +
    "}" +

    ".product-info-table td{" +
      "padding:5px 7px;" +
      "border-bottom:1px solid #d8d8d8;" +
      "background:#f8f8f8;" +
      "font-size:8.5px;" +
      "line-height:1.2;" +
      "vertical-align:top;" +
    "}" +

    ".product-info-table td:first-child{" +
      "width:38%;" +
      "background:#ededed;" +
      "font-weight:700;" +
    "}" +

    ".product-info-table a{" +
      "color:#111;" +
      "text-decoration:underline;" +
    "}" +

    ".product-overview{font-size:10px;line-height:1.5}.product-overview h2,.product-overview h3{font-size:12px}.product-overview p{margin:7px 0}.product-overview ul{padding-left:18px}" +
    ".product-description{" +
      "margin-top:7px;" +
      "padding:7px 8px;" +
      "border:1px solid #d8d8d8;" +
      "background:#f8f8f8;" +
      "font-size:9px;" +
      "line-height:1.25;" +
    "}" +

    ".master-price-table{" +
      "width:100%;" +
      "table-layout:auto;" +
      "border-collapse:collapse;" +
    "}" +

    ".master-price-table th{" +
      "padding:7px;" +
      "border:1px solid #c9c9c9;" +
      "background:#e8e8e8;" +
      "font-size:9px;" +
      "font-weight:700;" +
      "line-height:1.15;" +
      "text-align:left;" +
      "vertical-align:bottom;" +
      "text-transform:uppercase;" +
    "}" +

    ".master-price-table td{" +
      "padding:7px;" +
      "border:1px solid #d4d4d4;" +
      "background:#fafafa;" +
      "font-size:8.5px;" +
      "line-height:1.3;" +
      "vertical-align:top;" +
      "overflow-wrap:anywhere;" +
    "}" +

    ".master-price-table .product-column{" +
      "width:auto;" +
    "}" +

    ".master-price-table th:nth-child(2)," +
    ".master-price-table td:nth-child(2){" +
      "width:auto;" +
    "}" +

    ".master-price-table th:nth-child(3)," +
    ".master-price-table td:nth-child(3){" +
      "width:auto;" +
    "}" +

    ".master-price-table th:nth-child(4)," +
    ".master-price-table td:nth-child(4){" +
      "width:auto;" +
    "}" +

    ".master-price-table .money{" +
      "width:14%;" +
      "text-align:right;" +
      "white-space:nowrap;" +
    "}" +

    ".master-price-table .product-price{" +
      "font-size:10px;" +
      "font-weight:700;" +
    "}" +

    ".variant-sku{" +
      "margin-top:3px;" +
      "font-size:7.5px;" +
      "font-weight:400;" +
      "color:#555;" +
    "}" +

    ".included-label{" +
      "display:block;" +
      "margin-top:2px;" +
      "color:#777;" +
      "font-size:6px;" +
      "font-weight:400;" +
      "text-transform:none;" +
    "}" +

    ".price-validity{" +
      "margin-top:8px;" +
      "padding:7px 9px;" +
      "border:1px solid #d5d5d5;" +
      "background:#f3f3f3;" +
      "font-size:9px;" +
      "line-height:1.3;" +
    "}" +

    ".all-options-table{" +
      "width:100%;" +
      "border-collapse:collapse;" +
    "}" +

    ".all-options-table th{" +
      "padding:5px 6px;" +
      "border:1px solid #c9c9c9;" +
      "background:#e8e8e8;" +
      "font-size:9px;" +
      "text-align:left;" +
      "text-transform:uppercase;" +
    "}" +

    ".all-options-table td{" +
      "padding:5px 6px;" +
      "border:1px solid #d2d2d2;" +
      "background:#f8f8f8;" +
      "font-size:9px;" +
      "line-height:1.25;" +
      "vertical-align:top;" +
    "}" +

    ".all-options-table .option-name{" +
      "width:auto;" +
      "font-weight:700;" +
    "}" +

    ".vertical-options{" +
      "column-count:3;" +
      "column-gap:16px;" +
      "margin:0;" +
      "padding:0;" +
      "list-style:none;" +
    "}" +

    ".option-applicability{display:block;color:#666;font-size:8px;margin-top:2px}.shared-standard{font-size:9px;margin:8px 0}.all-options-table .vertical-options{column-count:2}" +
    ".vertical-options li{" +
      "position:relative;" +
      "margin:0 0 2px;" +
      "padding-left:8px;" +
      "break-inside:avoid;" +
    "}" +

    ".vertical-options li:before{" +
      "position:absolute;" +
      "left:0;" +
      "content:'•';" +
      "color:#f49600;" +
    "}" +

    ".product-detail-list{" +
      "display:block;" +
      "width:100%;" +
    "}" +

    ".detail-card{" +
      "display:block;" +
      "width:100%;" +
      "margin:0 0 7px;" +
      "padding:8px 10px;" +
      "border:1px solid #d8d8d8;" +
      "background:#f1f1f1;" +
      "break-inside:avoid;" +
      "page-break-inside:avoid;" +
    "}" +

    ".detail-body h2,.detail-body h3{font-size:10px;margin:8px 0 5px}" +
    ".detail-card h3{" +
      "margin:0 0 5px;" +
      "padding-bottom:4px;" +
      "border-bottom:1px solid #d2d2d2;" +
      "font-size:9px;" +
      "font-weight:700;" +
      "line-height:1.2;" +
      "text-transform:uppercase;" +
    "}" +

    ".detail-body{" +
      "font-size:9px;" +
      "line-height:1.35;" +
      "color:#222;" +
      "overflow-wrap:anywhere;" +
    "}" +

    ".detail-body p{" +
      "margin:0 0 5px;" +
    "}" +

    ".detail-body p:last-child{" +
      "margin-bottom:0;" +
    "}" +

    ".detail-body ul," +
    ".detail-body ol{" +
      "margin:3px 0 5px;" +
      "padding-left:15px;" +
    "}" +

    ".detail-body li{" +
      "margin-bottom:2px;" +
    "}" +

    ".detail-body table{" +
      "width:100%;" +
      "border-collapse:collapse;" +
      "font-size:6.5px;" +
    "}" +

    ".detail-body th," +
    ".detail-body td{" +
      "padding:3px 4px;" +
      "border:1px solid #ccc;" +
    "}" +

    ".empty{" +
      "padding:9px;" +
      "background:#eee;" +
      "color:#666;" +
      "font-size:9px;" +
      "font-style:italic;" +
    "}" +

    ".notice{" +
      "margin-top:10px;" +
      "padding:8px;" +
      "border:1px solid #ccc;" +
      "background:#f1f1f1;" +
      "color:#555;" +
      "font-size:9px;" +
      "line-height:1.3;" +
    "}" +

    ".print-footer{" +
      "display:none;" +
    "}" +

    "@media print{" +

      ".toolbar{" +
        "display:none!important;" +
      "}" +

      "body{" +
        "margin:0;" +
        "background:#fff;" +
      "}" +

      ".sheet{" +
        "max-width:none;" +
        "padding:0 0 28px;" +
      "}" +

      ".detail-card,tr{" +
        "break-inside:avoid;" +
        "page-break-inside:avoid;" +
      "}" +

      ".print-footer{" +
        "display:block;" +
        "position:fixed;" +
        "right:0;" +
        "bottom:0;" +
        "left:0;" +
        "padding-top:6px;" +
        "border-top:1px solid #d0d0d0;" +
        "background:#fff;" +
        "color:#666;" +
        "font-size:9px;" +
      "}" +

    "}" +

    "<\/style>" +
    "<\/head>" +

    "<body>" +

    "<main class='sheet' id='mf-product-info-root'>" +

      "<div class='toolbar'>" +

        "<button type='button' onclick='window.print()'>" +
          "PRINT INFORMATION SHEET" +
        "<\/button>" +

        "<button type='button' class='download' onclick='downloadProductInfo()'>" +
          "DOWNLOAD PDF" +
        "<\/button>" +

      "<\/div>" +

      "<header class='header'>" +

        "<div>" +
          logoHtml +
        "<\/div>" +

        "<div class='header-text'>" +

          "<h1>" +
            escapeHtml(
              productData.title
            ) +
          "<\/h1>" +

          "<p class='document-name'>" +
            "Product Information Sheet" +
          "<\/p>" +

          "<p class='effective-date'>" +
            "Effective " +
            escapeHtml(
              dateData.display
            ) +
          "<\/p>" +

        "<\/div>" +

      "<\/header>" +

      "<div class='top-grid'>" +

        "<section>" +

          "<div class='section-title'>" +
            "Product Images" +
          "<\/div>" +

          imagesHtml +

        "<\/section>" +

        "<section>" +

          "<div class='section-title'>" +
            "Product Information" +
          "<\/div>" +

          renderProductInformation() +

        "<\/section>" +

      "<\/div>" +

      (productData.descriptionHtml ? "<section class='product-overview'><div class='section-title'>Overview</div>" + panelHtml(productData.title, (function () { var div = document.createElement('div'); div.innerHTML = productData.descriptionHtml; return div; })()).html + "</section>" : "") +
      "<div class='section-title'>" +
        "Sizes & Specifications" +
      "<\/div>" +

      renderMasterPriceTable(
        easifyGroups
      ) +

      "<div class='section-title'>" +
        "Available Options" +
      "<\/div>" +

      (completeProductSheet ? "<p style='font-size:9px'>Shared choices are listed once. Size-specific burners and media quantities are shown in Sizes &amp; Specifications. Size labels below refer to overall product dimensions.</p>" : '') +
      renderAllOptions(
        easifyGroups,
        visibleLabels
      ) +

      "<div class='section-title'>" +
        "Additional Product Information" +
      "<\/div>" +

      renderProductSections(
        productSections
      ) +

      "<div class='notice'>" +
        "Product specifications, configurations and installation requirements should be verified against the final approved order. Professional installation is required where applicable." +
      "<\/div>" +

      "<div class='print-footer'>" +

        "© Modofire • Product Information Sheet • " +

        escapeHtml(
          dateData.display
        ) +

        " • info@modofire.com" +

      "<\/div>" +

    "<\/main>" +

    "<scr" +
    "ipt>" +

    "function downloadProductInfo(){" +

      "var element=document.getElementById('mf-product-info-root');" +

      "var product=" +
        JSON.stringify(
          productData.title
        ) +
      ";" +

      "var date=" +
        JSON.stringify(
          dateData.file
        ) +
      ";" +

      "product=String(product||'modofire')" +
        ".replace(/[^a-z0-9]+/gi,'_')" +
        ".replace(/^_+|_+$/g,'')" +
        "||'modofire';" +

      "if(window.html2pdf){" +

        "html2pdf()" +

        ".set({" +
          "margin:.20," +
          "filename:product+'_product_information_sheet_'+date+'.pdf'," +
          "image:{type:'jpeg',quality:.98}," +
          "html2canvas:{scale:2,useCORS:true,allowTaint:true,scrollY:0}," +
          "jsPDF:{unit:'in',format:'letter',orientation:'portrait'}," +
          "pagebreak:{mode:['css','legacy'],avoid:['tr','.detail-card']}" +
        "})" +

        ".from(element)" +
        ".save();" +

      "}else{" +
        "window.print();" +
      "}" +

    "}" +

    "<\/scr" +
    "ipt>" +

    "<\/body>" +
    "<\/html>";


  if (resourceMode && frame) {
    frame.srcdoc = documentHtml;
    return;
  }

  var blob =
    new Blob(
      [documentHtml],
      {
        type:
          "text/html"
      }
    );


  var blobUrl =
    URL.createObjectURL(
      blob
    );


  var newWindow = sheetWindow && !sheetWindow.closed ? sheetWindow : null;
  if (newWindow) newWindow.location.replace(blobUrl);
  else newWindow = window.open(blobUrl, "_blank");


  if (!newWindow) {
    URL.revokeObjectURL(
      blobUrl
    );

    throw new Error(
      "The browser blocked the product information sheet. Please allow pop-ups for this website."
    );
  }


  window.setTimeout(
    function () {
      URL.revokeObjectURL(
        blobUrl
      );
    },
    120000
  );
}


/* =========================================================
   BUTTON
========================================================= */

btn.addEventListener(
  "click",
  function () {
    if (!resourceMode) sheetWindow = window.open("", "_blank");
    if (sheetWindow && !resourceMode) { sheetWindow.document.title = "Product Information Sheet"; sheetWindow.document.body.textContent = "Building Product Information Sheet..."; }
    var originalText =
      btn.textContent;

    btn.disabled =
      true;

    btn.textContent =
      "Building Product Information Sheet...";


    window.setTimeout(
      function () {
        try {
          var scope =
            getProductScope();


          var easifyGroups =
            collectEasifyGroups(
              scope
            );


          var visibleLabels =
            collectVisibleOptionLabels(
              scope
            );


          var productSections =
            collectProductSections(
              scope
            );


          var imageUrls =
            [];


          var fixedLogo =
            fixUrl(
              logoUrl
            );


          if (fixedLogo) {
            imageUrls.push(
              fixedLogo
            );
          }


          productData.images
            .slice(
              0,
              3
            )
            .forEach(
              function (imageUrl) {
                var fixedImage =
                  fixUrl(
                    imageUrl
                  );

                if (fixedImage) {
                  imageUrls.push(
                    fixedImage
                  );
                }
              }
            );


          imageUrls =
            imageUrls.filter(
              function (
                value,
                index,
                array
              ) {
                return (
                  array.indexOf(
                    value
                  ) === index
                );
              }
            );


          var imageMap =
            {};


          var imagePromises =
            imageUrls.map(
              function (url) {
                return fetchBase64(
                  url
                ).then(
                  function (base64) {
                    if (base64) {
                      imageMap[url] =
                        base64;
                    }
                  }
                );
              }
            );


          Promise.all(
            imagePromises
          )

          .then(
            function () {
              buildDocument(
                imageMap,
                easifyGroups,
                visibleLabels,
                productSections
              );
            }
          )

          .catch(
            function () {
              buildDocument(
                imageMap,
                easifyGroups,
                visibleLabels,
                productSections
              );
            }
          )

          .finally(
            function () {
              btn.disabled =
                false;

              btn.textContent =
                originalText;
            }
          );


        } catch (error) {
          console.error(
            "Modofire Product Information Sheet Error:",
            error
          );


          window.alert(
            error &&
            error.message
              ? error.message
              : "The product information sheet could not be created."
          );


          btn.disabled =
            false;

          btn.textContent =
            originalText;
        }
      },
      700
    );
  }
);

if (resourceMode) {
  var overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:#fff;color:#111;display:flex;flex-direction:column';
  var bar = document.createElement('nav');
  bar.setAttribute('aria-label', 'Information sheet');
  bar.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:16px;padding:12px 20px;background:#111;color:#ece0cc;font:14px sans-serif';
  var back = document.createElement('a');
  back.href = '/pages/resources-1';
  back.textContent = '← Resources';
  back.style.color = 'inherit';
  var choose = document.createElement('a');
  var chooseUrl = new URL(window.location.href);
  chooseUrl.searchParams.delete('mf_sheet');
  chooseUrl.hash = '';
  choose.href = chooseUrl.pathname + chooseUrl.search;
  choose.textContent = 'Product page / sizes and options';
  choose.style.color = 'inherit';
  bar.append(back, choose);
  var frame = document.createElement('iframe');
  frame.title = productData.title + ' information sheet';
  frame.style.cssText = 'width:100%;flex:1;border:0;background:white';
  overlay.append(bar, frame);
  document.body.append(overlay);
  sheetWindow = frame.contentWindow;
  frame.contentDocument.body.textContent = 'Loading current product information...';
  var started = false;
  function waitForOptions() {
    var startedAt = Date.now();
    var previous = '';
    var stable = 0;
    var timer = window.setInterval(function () {
      var fields = document.querySelectorAll('.po-field-root');
      var signature = Array.prototype.map.call(fields, function (field) { return field.textContent; }).join('|');
      stable = signature && signature === previous ? stable + 1 : 0;
      previous = signature;
      if ((fields.length && stable >= 3) || Date.now() - startedAt > 15000) {
        window.clearInterval(timer);
        if (!started) { started = true; btn.click(); }
      }
    }, 500);
  }
  if (document.readyState === 'complete') waitForOptions();
  else window.addEventListener('load', waitForOptions, {once:true});
}

}
function initializeAll() { document.querySelectorAll('[data-mf-sheet]').forEach(initialize); }
initializeAll();
document.addEventListener('shopify:section:load', initializeAll);
})();



